import { useParams } from "react-router";
import { useGetApiTenantsTenantId } from "@/lib/api/generated/tenants/tenants";
import { useAuth } from "@/features/auth/auth-provider";

export function useTenantContext() {
  const { tenant: authTenant } = useAuth();
  const { tenantId } = useParams<{ tenantId: string }>();
  const activeTenantId = tenantId ?? authTenant?.tenantId ?? "";
  const { data: tenant, isLoading, error } = useGetApiTenantsTenantId(activeTenantId, {
    query: { enabled: Boolean(activeTenantId) },
  });
  return { tenantId: activeTenantId, tenant, isLoading, error };
}
